// extracted by mini-css-extract-plugin
export default {"Emojify":"bbx_a bhy_g"};